const cycleHire = (state = [], action) => {

	switch (action.type) {

		case 'PUT_CYCLE_HIRE':

			const { cycleHire, cycleHireType } = action.payload;

			return {
				...state,
				hireCompany: {
					...state.cycleHire,
					[cycleHireType]: {
						results: cycleHire,
					}
				},
			};

		case 'CLEAR_CYCLE_HIRE': {

			return {
				...state,
				hireCompany: {},
			};
		}

		case 'REMOVE_CYCLE_HIRE': {

			const { cycleHireType } = action.options;

			return {
				...state,
				hireCompany: {
					...state.cycleHire,
					[cycleHireType]: null
				}
			};
		}

		case 'TOGGLE_CYCLE_HIRE':

			return {
				...state,
				show: !state.shown
			};

		default:
			return state;

	}

}
export default cycleHire;



// WEBPACK FOOTER //
// ./src/reducers/cycleHire.js